import { render, staticRenderFns } from "./Compte_salon.vue?vue&type=template&id=58b6c664&scoped=true&"
import script from "./Compte_salon.vue?vue&type=script&lang=js&"
export * from "./Compte_salon.vue?vue&type=script&lang=js&"
import style0 from "./Compte_salon.vue?vue&type=style&index=0&id=58b6c664&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b6c664",
  null
  
)

export default component.exports